module.exports = __webpack_public_path__ + "static/media/Sketch4.d85ddb6c.jpg";